import BasicLayout from '../../core/BasicLayout';
import Locked from '../../core/Locked';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Errored from '../Errored';
import { checkIRI, getGraphFromProject, processHashLocation } from '../utils/utils';

class ProjectWrapper extends Component {

  state = {
    projectIRI: null,
    isErrored: false
  };

  static getDerivedStateFromProps(props) {
    const paramsMap = processHashLocation(props.location);
    const projectIRI = paramsMap.get("project");
    let isErrored = false;
    try {
      projectIRI && projectIRI !== "" && getGraphFromProject(projectIRI);
    }
    catch (e) {
      isErrored = true;
    }
    isErrored = !projectIRI || projectIRI === "" || !checkIRI(projectIRI);
    return {
      projectIRI,
      isErrored
    };
  }

  render() {

    const { projectIRI, isErrored } = this.state;
    const { applicationTitle, applicationURL, component, lockedGraphs } = this.props;
    const WrappedComponent = component;

    if (isErrored) return <Errored data={{ message: "An invalid project IRI has been supplied." }} />;

    const graph = projectIRI && projectIRI !== "" ? getGraphFromProject(projectIRI) : null;
    if (lockedGraphs && lockedGraphs.includes(graph)) return <BasicLayout><Locked /></BasicLayout>;
    if (!graph) return <BasicLayout />;

    return (
      <WrappedComponent {...this.props}
        id={projectIRI}
        key={projectIRI}
        graph={graph}
        project={projectIRI}
        applicationTitle={applicationTitle}
        applicationURL={applicationURL}
      />
    );
  }
}

ProjectWrapper.propTypes = {
  lockedGraphs: PropTypes.array,
  component: PropTypes.func.isRequired,
  applicationTitle: PropTypes.string.isRequired,
  applicationURL: PropTypes.string.isRequired
};

export default ProjectWrapper;